import { idType, selectItemType } from '@src/types';
import store from '@store/store';

export type FilterErrorIndicator = {
  field: boolean | null;
  operator: boolean | null;
  value: boolean | null;
};

export type filterOptionType = {
  label?: string;
  name: string;
  filterKey?: string;
  filterType: string;
  filterSelectName: SelectType;
  filterOptions?: Array<{
    id: idType;
    value: string | number | boolean;
    label: string;
  }>;
  requestByAsync?: (param: any) => Promise<any>;
  disabled?: boolean;
  isDisabled?: boolean;
};

export type SelectType =
  | 'lob'
  | 'serviceCategory'
  | 'rideServiceCategory'
  | 'payerMot'
  | 'memberMot'
  | 'contractorMot'
  | 'noteCategory'
  | 'user'
  | 'changedBy'
  | 'createdBy'
  | 'viewedBy'
  | 'contactRelation'
  | 'primaryType'
  | 'limitType'
  | 'rideContractor'
  | 'rideStatus'
  | 'userType'
  | 'userPermissions'
  | 'location'
  | 'preferContractor'
  | 'preferAssignmentType'
  | 'activityStatus';

export type OperatorInfo = {
  key: string;
  type: string;
  operators: Array<selectItemType>;
  selectName: SelectType;
  booleanOptions: Array<{
    id: idType;
    value: string | number | boolean;
    label: string;
  }>;
};

export const filterOperators = [
  { id: 1, label: 'Contains', value: 'contains' },
  { id: 2, label: 'Equals', value: 'equals' },
  { id: 3, label: 'Not Equals', value: 'notEquals' },
  { id: 4, label: 'Less or Equal', value: 'lessThanOrEqualTo' },
  { id: 5, label: 'Greater or Equal', value: 'greaterThanOrEqualTo' },
  { id: 6, label: 'Range', value: 'range' },
  { id: 7, label: 'Equals', value: 'contains' },
];

export const getFilterOperator = {
  boolean: [filterOperators[1]],
  text: [filterOperators[0], filterOperators[1]],
  select: [filterOperators[6]],
  localSelect: [filterOperators[1]],
  date: [filterOperators[3], filterOperators[4], filterOperators[5]],
  time: [filterOperators[3], filterOperators[4]],
  dateTime: [filterOperators[3], filterOperators[4], filterOperators[5]],
  number: [filterOperators[1]],
};

export const getAvailableOperators = (column: filterOptionType) => {
  return {
    operators: getFilterOperator[column?.filterType || ''],
    type: column?.filterType || '',
    selectName: column.filterSelectName || '',
    key: column?.filterKey || '',
    booleanOptions: column?.filterOptions || [
      { id: 1, value: true, label: 'Active' },
      { id: 2, value: false, label: 'Inactive' },
    ],
  };
};

export const getFilterSelectData = (key: string) => {
  const data = store.getState().selects;
  const selects = {
    lob: 'businessTypes',
    serviceCategory: 'categoryTypes',
    rideCategoryTypes: 'rideServiceCategoryTypes',
    payerMot: 'modeOfTransportAllTypes',
    memberMot: 'modeOfTransportAllTypes',
    contractorMot: 'modeOfTransportAllTypes',
    modeOfTransportType: 'contractorsLosAllType',
    noteCategory: 'noteCategory',
    createdBy: 'createdByFiltration',
    changedBy: 'changedByFiltration',
    viewedBy: 'viewedByFiltration',
    notedBy: 'notedByFiltration',
    contactRelation: 'relationshipSelect',
    limitType: 'limitsTypes',
    userType: 'userTypeFiltration',
    userPermissions: 'userPermissionsFiltration',
    healthPlan: 'healthPlanSelectDate',
    rideContractor: 'contractorsType',
    rideStatus: 'rideSegmentStatus',
    location: 'locationsSelect',
    preferContractor: 'preferenceActiveContractors',
    preferAssignmentType: 'preferenceAssignmentTypes',
    activityStatus: 'activityStatus',
  };

  return data[selects[key]] || [];
};
